import { render, staticRenderFns } from "./TargetGroupTagWithTooltip.vue?vue&type=template&id=0115fd26&scoped=true&"
import script from "./TargetGroupTagWithTooltip.vue?vue&type=script&lang=js&"
export * from "./TargetGroupTagWithTooltip.vue?vue&type=script&lang=js&"
import style0 from "./TargetGroupTagWithTooltip.vue?vue&type=style&index=0&id=0115fd26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0115fd26",
  null
  
)

export default component.exports